import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import { buildHoverList, CHIP_AGGREGATION_THRESHOLD, chipModelName, useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const ModelResultsChips = observer(
    (props: IAppliedFilterChipComponent) => {
        const applicationFiltersStore = useChipFiltersStore(props);

        if (
            !applicationFiltersStore.modelResults ||
            applicationFiltersStore.modelResults.length === 0
        ) {
            return null;
        }

        return applicationFiltersStore.modelResults.map((model) => {
            const resultCount = model.results.length;
            const modelKey = model.id ?? model.name;
            const displayName = chipModelName(model.name);

            if (resultCount > CHIP_AGGREGATION_THRESHOLD) {
                return (
                    <AppliedFilterChip
                        key={`${modelKey}-group`}
                        disabled={props.disabled}
                        isApplicable={props.isApplicable}
                        onRemove={() => {
                            applicationFiltersStore.setModelResults(
                                (
                                    applicationFiltersStore.modelResults ?? []
                                ).filter(
                                    (m) => (m.id ?? m.name) !== modelKey,
                                ),
                            );
                        }}
                        tooltipContent={buildHoverList(model.results)}
                    >
                        {resultCount} {displayName} Results
                    </AppliedFilterChip>
                );
            }

            return model.results.map((result) => (
                <AppliedFilterChip
                    key={`${modelKey}-${result}`}
                    disabled={props.disabled}
                    isApplicable={props.isApplicable}
                    onRemove={() => {
                        applicationFiltersStore.removeResultFromModel(
                            model,
                            result,
                        );
                    }}
                >
                    {displayName} Results: {result}
                </AppliedFilterChip>
            ));
        });
    },
);
